module.exports = __webpack_public_path__ + "57a92861fc822895389f9b453e3d5f74.pdf";